export const socialsData = {
    github: 'https://github.com/yashdesai28',
   
    linkedIn: 'https://www.linkedin.com/in/yash-desai-857b15209/',
    twitter: 'https://twitter.com/yashdesai______',
 
    stackOverflow: 'https://stackoverflow.com/users/20881205/yash-desai',
    mail: 'yashdesai281@gmail.com',
}